var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18764_31087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99975 6.99996C1.90513 7.00028 1.81237 6.97375 1.73223 6.92345C1.65209 6.87315 1.58787 6.80114 1.54703 6.71579C1.50618 6.63044 1.4904 6.53525 1.5015 6.44129C1.5126 6.34732 1.55014 6.25844 1.60975 6.18496L6.55975 1.08496C6.59688 1.0421 6.64748 1.01314 6.70324 1.00283C6.759 0.992514 6.81661 1.00147 6.86662 1.02821C6.91662 1.05496 6.95604 1.09791 6.97842 1.15001C7.00079 1.20212 7.00479 1.26028 6.98975 1.31496L6.02975 4.32496C6.00144 4.40072 5.99194 4.48222 6.00205 4.56246C6.01216 4.64271 6.04158 4.7193 6.0878 4.78567C6.13401 4.85205 6.19564 4.90622 6.26739 4.94354C6.33914 4.98086 6.41887 5.00022 6.49975 4.99996H9.99975C10.0944 4.99964 10.1871 5.02617 10.2673 5.07647C10.3474 5.12677 10.4116 5.19878 10.4525 5.28413C10.4933 5.36948 10.5091 5.46467 10.498 5.55863C10.4869 5.65259 10.4494 5.74148 10.3898 5.81496L5.43975 10.915C5.40262 10.9578 5.35202 10.9868 5.29626 10.9971C5.2405 11.0074 5.18289 10.9985 5.13289 10.9717C5.08288 10.945 5.04346 10.902 5.02108 10.8499C4.99871 10.7978 4.99471 10.7396 5.00975 10.685L5.96975 7.67496C5.99806 7.5992 6.00757 7.5177 5.99746 7.43746C5.98735 7.35721 5.95792 7.28062 5.91171 7.21425C5.86549 7.14787 5.80387 7.0937 5.73211 7.05638C5.66036 7.01906 5.58063 6.9997 5.49975 6.99996H1.99975Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18764_31087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIcon);
export default __webpack_public_path__ + "static/media/connect-icon.76c296941383e66fbab420458fc696e2.svg";
export { ForwardRef as ReactComponent };